"use strict";

exports.__esModule = true;
exports.isPrivate = isPrivate;
exports.isMembersOnly = isMembersOnly;
exports.isPublic = isPublic;
exports.hasCategoryGroup = hasCategoryGroup;
exports.isChangedFromPrivate = isChangedFromPrivate;
exports.didCategoryBecomeMoreRestricted = didCategoryBecomeMoreRestricted;
exports.isVisibleToMembersOnly = isVisibleToMembersOnly;

var _categoryTypes = require("../constants/category-types");

var _categoriesManager = require("../constants/categories-manager");

var _categoryVisibility = require("../constants/category-visibility");

function isPrivate(category) {
  return category && category.type === _categoryTypes.CATEGORY_TYPE_PRIVATE;
}

function isMembersOnly(category) {
  if (!category) {
    return;
  }

  return category.type ? category.type === _categoryTypes.CATEGORY_TYPE_MEMBERS_ONLY : category.isPrivate;
}

function isPublic(category) {
  return category.type ? category.type === _categoryTypes.CATEGORY_TYPE_PUBLIC : !category.isPrivate;
}

function hasCategoryGroup(category) {
  return category.categoryGroupId !== _categoriesManager.TEMPLATE_CATEGORY_GROUP_ID && category.categoryGroupId !== undefined;
}

function isChangedFromPrivate(updatedCategory, initialCategory) {
  return !isPrivate(updatedCategory) && isPrivate(initialCategory);
}

function didCategoryBecomeMoreRestricted(updatedCategory, initialCategory) {
  return updatedCategory.type !== initialCategory.type && !isPublic(updatedCategory) && !isPrivate(initialCategory);
}

function isVisibleToMembersOnly(category) {
  return category && category.visible === _categoryVisibility.VISIBILITY_MEMBRES_ONLY;
}